<template>
    <v-autocomplete
            v-show="!(items.length === 1 && hideOnOne)"
            hide-details
            v-model="model"
            :items="items"
            item-text="name"
            item-value="id"
            :label="label || 'Sucursal' + (isMultiple ? 'es' : '')"
            prepend-inner-icon="fa-building"
            @click:clear="clear"
            return-object
            :filter="filter"
            :multiple="isMultiple"
            :disabled="loading || disabled || items.length === 0"
            :required="isRequired"
    >
        <template v-if="isMultiple" v-slot:selection="{ item, index }">
            <v-chip small v-if="index === 0">
                <span>{{ item.name }}</span>
            </v-chip>
            <span
                    v-if="index === 1"
                    class="grey--text caption"
            >({{ model.length - 1 }}+)</span>
        </template>

    </v-autocomplete>
</template>

<script>

    import {ApiUtils} from '@/utils/ApiUtils'
    import {hasAccessToOffice} from '@/utils/Auth'
    import {filterSelectorWithHeaders, filterUniqueIds} from '@/utils/Common'
    import {mapMutations, mapState, mapActions} from 'vuex'

    export default{
        props: [
            'default',
            'multiple',
            'required' ,
            'offices',
            'label',
            'disabled',
            'value',
            'onlyScoped',
            'hideOnOneItem'
        ],
        data(){
            return {
                model: this.isMultiple ? [] : null,
                loading: false
            }
        },
        watch: {
            model(val){
                this.$emit('change', val)
            },
            branchOffices(offices){
                this.$emit('loaded')
            },
            currentProvider(val){},
            value(val){

                if(val){
                    this.model = val
                }
            }
        },
        mounted(){
            this.model = this.branchOffices.length ? this.branchOffices[0] : null
            if (this.branchOffices.length === 0) {
                this.fetchBranchOffices()
            }else{
                this.$emit('loaded')
            }
        },
        methods: {
            ...mapActions(['fetchBranchOffices']),
            ...mapMutations(['showSnackBar']),
            filter: filterSelectorWithHeaders,
            clear(){
                this.model = []
            },
        },
        computed: {
                ...mapState(['currentProvider', 'branchOffices']),
            isMultiple(){
                return this.multiple != undefined && this.multiple !== false
            },

            isRequired(){
              return this.required != undefined && this.required !== false
            },

            hideOnOne(){
              return this.hideOnOneItem != undefined && this.hideOnOneItem !== false
            },

            fixedToScope(){
              return this.onlyScoped != undefined && this.onlyScoped !== false
            },

            items(){

                var vm = this
                var all = []

                if(!vm.branchOffices.length) return all

                var offices = vm.branchOffices

                offices.forEach((office) => {

                    all.push({
                        id: office.id,
                        name: office.name
                    })

                })

                if(vm.fixedToScope){
                    return all.filter(office => hasAccessToOffice(office.id))
                }

                return all

            }
        }
    }
</script>